export default {
  operations: 'operations',
  payments: 'payments',
  interchange: 'interchange',
  chargebacks: 'chargebacks',
  fraud: 'fraud',
  remittanceOperations: 'remittanceOperations',
  remittancePayments: 'remittancePayments',
  billingOperations: 'billingOperations',
};
